import { render, staticRenderFns } from "./sync-rule.vue?vue&type=template&id=2acfafa6&"
import script from "./sync-rule.vue?vue&type=script&lang=js&"
export * from "./sync-rule.vue?vue&type=script&lang=js&"
import style0 from "./sync-rule.vue?vue&type=style&index=0&id=2acfafa6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports